export default "__VITE_ASSET__DZFMVo6R__"